import { render, staticRenderFns } from "./VxStatus.vue?vue&type=template&id=16dc5e0e"
import script from "./VxStatus.vue?vue&type=script&lang=js"
export * from "./VxStatus.vue?vue&type=script&lang=js"
import style0 from "./VxStatus.vue?vue&type=style&index=0&id=16dc5e0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports